(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/registration/components/receipt/template', '<registration-receipt\n' + '  ng-if="campaign.type === \'reg_w_fund\' || campaign.type === \'ticketed\'"\n' + '  type="campaign.type"\n' + '></registration-receipt>\n' + '');
}]);
})();